<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { VueContentLoading } from "vue-content-loading";
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import { required } from "vuelidate/lib/validators"; // for validators
import DatePicker from "vue2-datepicker"; // add DatePicker
import FileServices from "../../../services/files";
import { swal } from "../../../helpers/handle_error.js";

export default {
  page: {
    title: "تحميل البيانات",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, VueContentLoading, AlertError, DatePicker },
  data() {
    return {
      title: "تحميل البيانات",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "تحميل البيانات",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      //Permission vars.
      hasLoanForm: false,
      hasLandForm: false,
      hasPilgrimageForm: false,
      hasScholarShipsForm: false,
      hasBoothsForm: false,
      hasHousingUnitsForm: false,
      hasGovernmentLoansForm: false,
      hasHealthCardForm: false,

      //form vars.
      forms: [],

      formExport: {
        formName: "",
        date: {
          from: "",
          to: "",
        },
        order: "",
      },

      //api uri.
      uri_excel: {
        booths: "booths/export/excel",
        loan_martyrs: "tasdeed/export/excel/martyrs",
        loan_woundeds: "tasdeed/export/excel/woundeds",
        land_martyrs: "taskeen/export/excel/martyrs",
        land_woundeds: "taskeen/export/excel/woundeds",
        pilgrimage: "pilgrimage/export/excel",
        scholar_ships: "scholar-ships/export/excel",
        housing_units_martyrs: "housing-units/export/excel/martyrs",
        housing_units_woundeds: "housing-units/export/excel/woundeds",
        housing_units_employees: "housing-units/export/excel/employees",
        government_loans_martyrs: "government-loans/export/excel/martyrs",
        government_loans_woundeds: "government-loans/export/excel/woundeds",
        government_loans_employees: "government-loans/export/excel/employees",
        health_card_martyrs: "health-card/export/excel/martyrs",
        plots_of_land_2_martyrs: "plots-of-land-2/export/excel/martyrs",
        plots_of_land_2_woundeds: "plots-of-land-2/export/excel/woundeds",
        plots_of_land_2_employees: "plots-of-land-2/export/excel/employees",
      },

      uri_zip: {
        loan_martyrs: "tasdeed/export/zip/martyrs",
        loan_woundeds: "tasdeed/export/zip/woundeds",
        land_martyrs: "taskeen/export/zip/martyrs",
        land_woundeds: "taskeen/export/zip/woundeds",
        pilgrimage: "pilgrimage/export/zip",
        scholar_ships: "scholar-ships/export/zip",
        housing_units_martyrs: "housing-units/export/zip/martyrs",
        housing_units_woundeds: "housing-units/export/zip/woundeds",
        housing_units_employees: "housing-units/export/zip/employees",
        government_loans_martyrs: "government-loans/export/zip/martyrs",
        government_loans_woundeds: "government-loans/export/zip/woundeds",
        government_loans_employees: "government-loans/export/zip/employees",
        health_card_martyrs: "health-card/export/zip/martyrs",
        plots_of_land_2_martyrs: "plots-of-land-2/export/zip/martyrs",
        plots_of_land_2_woundeds: "plots-of-land-2/export/zip/woundeds",
        plots_of_land_2_employees: "plots-of-land-2/export/zip/employees",
      },

      showAlert: false,
      loadingContent: true,
      submit: false,
      loadingButtonExportExcel: false,
      loadingButtonExportZip: false,
      downloadProgressValue: 0,
      showDownloadProgress: false,
    };
  },
  // vuelidate
  validations: {
    formExport: {
      formName: { required },
      date: {
        from: { required },
        to: { required },
      },
      order: { required },
    },
  },
  computed: {
    ...mapGetters("auth", ["getUser"]),
    getFileName() {
      return this.formExport.formName.text + (this.formExport.formName.value == "booths" ? ".xlsx" : "");
    },
    downloadProgress: {
      get() {
        return this.showDownloadProgress;
      },
      set(value) {
        this.showDownloadProgress = value == true;
        this.downloadProgressValue = 0;
      },
    },
  },
  methods: {
    ...mapActions("auth", ["hasAllPermission"]),
    handleError(error) {
      if (FileServices.axios.isCancel(error)) {
        // Request was canceled
        alert('Request canceled', error);
      }
      else
      {
        try {
          this.showAlert = true;
          if (error.response.status == 422)
            this.errors = Object.values(error.response.data.errors);
          else
            this.errors = [
              `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
            ];
        } catch (error) {
          swal.error("لا يمكن تحميل الملف");
        }
      }
    },
    download(_uri) {
      this.$v.$touch();
      if (this.$v.$error) return;

      if (!this[_uri][this.formExport.formName.value]) return;

      // to form submit after this
      if (_uri == "uri_excel") this.loadingButtonExportExcel = true;
      else this.loadingButtonExportZip = true;

      this.errors = [];

      let uri = this[_uri][this.formExport.formName.value];

      let params = {
        from: this.formExport.date.from,
        to: this.formExport.date.to,
        order: this.formExport.order,
      };

      FileServices.download(uri, { params: params })
        .then(() => {
          this.downloadProgress = true;
          params.download = 1; //to download file.
          FileServices.download(
            uri,
            { params: params, responseType: "blob" },
            this.onDownloadProgress
          )
            .then((response) => FileServices.responseBlob(response, this.getFileName))
            .catch(this.handleError)
            .finally(() =>
              setTimeout(() => {
                this.downloadProgress = false;
              }, 2000)
            );
        })
        .catch(this.handleError)
        .finally(() => {
          this.loadingButtonExportExcel = false;
          this.loadingButtonExportZip = false;
        });
    },
    onDownloadProgress(event) {
      this.downloadProgressValue = parseInt(
        Math.round((event.loaded / event.total) * 100)
      );
    },
    cancelDownload(){
      FileServices.cancelDownload();
      this.downloadProgress = false;
    }
  },
  created() {
    this.hasBoothsForm = this.getUser.hasPermission("export_to_excel_booths");
    this.hasLoanForm = this.getUser.hasPermission("export_to_excel_loan");
    this.hasLandForm = this.getUser.hasPermission("export_to_excel_land");
    this.hasPilgrimageForm = this.getUser.hasPermission("export_to_excel_pilgrimage");
    this.hasScholarShipsForm = this.getUser.hasPermission("export_to_excel_scholarships");
    this.hasHousingUnitsForm = this.getUser.hasPermission("export_to_excel_housingunits");
    this.hasGovernmentLoansForm = this.getUser.hasPermission("export_to_excel_governmentloans");
    this.hasHealthCardForm = this.getUser.hasPermission("export_to_excel_healthcard");
    this.hasPlotsOfLand2Form = this.getUser.hasPermission("export_to_excel_plotsofland");

    if (this.hasBoothsForm)
      this.forms.push({ value: "booths", text: "استمارة حجز بوث" });

    if (this.hasLoanForm)
      this.forms.push(
        { value: "loan_martyrs", text: "استمارة القروض الحكومية (الشهداء)" },
        { value: "loan_woundeds", text: "استمارة القروض الحكومية (الجرحى)" }
      );

    if (this.hasLandForm)
      this.forms.push(
        { value: "land_martyrs", text: "استمارة قطع الاراضي والبدل النقدي (الشهداء)" },
        { value: "land_woundeds", text: "استمارة قطع الاراضي والبدل النقدي (الجرحى)" }
      );

    if (this.hasPilgrimageForm)
      this.forms.push({ value: "pilgrimage", text: "استمارة الحج" });

    if (this.hasScholarShipsForm)
      this.forms.push({ value: "scholar_ships", text: "استمارة المنح الدراسية" });

    if (this.hasHousingUnitsForm)
      this.forms.push(
        { value: "housing_units_martyrs", text: "استمارة الوحدات السكنية (الشهداء)" },
        { value: "housing_units_woundeds", text: "استمارة الوحدات السكنية (الجرحى)" },
        { value: "housing_units_employees", text: "استمارة الوحدات السكنية (المنتسبين)" }
      );

    if (this.hasGovernmentLoansForm)
      this.forms.push(
        { value: "government_loans_martyrs", text: "استمارة القروض الحكومية (الشهداء)" },
        { value: "government_loans_woundeds", text: "استمارة القروض الحكومية (الجرحى)" },
        { value: "government_loans_employees", text: "استمارة القروض الحكومية (المنتسبين)" }
      );

    if (this.hasHealthCardForm)
      this.forms.push({ value: "health_card_martyrs", text: "استمارة الحالة الصحية" });

    if (this.hasPlotsOfLand2Form)
      this.forms.push(
        { value: "plots_of_land_2_martyrs", text: "استمارة قطع الاراضي (الشهداء)" },
        { value: "plots_of_land_2_woundeds", text: "استمارة قطع الاراضي (الجرحى)" },
        { value: "plots_of_land_2_employees", text: "استمارة قطع الاراضي (المنتسبين)" }
      );

    if (this.$route.query.form == "booths" && this.hasBoothsForm)
      this.formExport.formName = this.forms.find((form) => form.value == "booths");

    this.loadingContent = false;
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <AlertError :errors="errors" :showDismissibleAlert="showAlert" />

            <b-form v-if="!loadingContent" class="mb-3 mt-4">
              <div class="row">
                <div v-if="downloadProgress" class="col-sm-12 pt-1">
                  <b-alert show variant="secondary" class="con-progress">
                    <b-progress height="20px" class="tag-progress">
                      <b-progress-bar
                        :value="downloadProgressValue"
                        :label="downloadProgressValue + '%'"
                      ></b-progress-bar>
                    </b-progress>
                    <b-button @click="cancelDownload()" variant="danger" class="btn-sm">
                      <i class="bx bx-x font-size-16 align-middle"></i>
                    </b-button>
                  </b-alert>
                </div>

                <b-form-group
                  class="col-md-6 mb-3"
                  label="الاستمارة :"
                  label-for="formExport.formName"
                >
                  <select
                    class="form-control select-p"
                    v-model="formExport.formName"
                    :class="{ 'is-invalid': $v.formExport.formName.$error }"
                    id="formExport.formName"
                  >
                    <option value="">حدد الاستمارة</option>
                    <option
                      v-for="form in forms"
                      v-bind:value="{ value: form.value, text: form.text }"
                      v-bind:key="form.value"
                    >
                      {{ form.text }}
                    </option>
                  </select>
                  <div v-if="$v.formExport.formName.$error" class="invalid-feedback">
                    <span v-if="!$v.formExport.formName.required">
                      هذا الحقل الزامي
                    </span>
                  </div>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="ترتيب فرز البيانات :"
                  label-for="formExport.order"
                >
                  <select
                    class="form-control select-p"
                    v-model="formExport.order"
                    :class="{ 'is-invalid': $v.formExport.order.$error }"
                    id="formExport.formName"
                  >
                    <option value="">حدد نوع الفرز</option>
                    <option value="desc">فرز تنازلي</option>
                    <option value="asc">فرز تصاعدي</option>
                  </select>
                  <div v-if="$v.formExport.order.$error" class="invalid-feedback">
                    <span v-if="!$v.formExport.order.required"> هذا الحقل الزامي </span>
                  </div>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="من : "
                  label-for="formExport.date.from"
                >
                  <date-picker
                    id="formExport.date.from"
                    type="date"
                    lang="ar"
                    value-type="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    placeholder='ادخل الصيغة التالية   "يوم - شهر - سنة"'
                    v-model="formExport.date.from"
                    :class="{ 'is-invalid': $v.formExport.date.from.$error }"
                  ></date-picker>
                  <div v-if="$v.formExport.date.from.$error" class="invalid-feedback">
                    <span v-if="!$v.formExport.date.from.required">هذا الحقل الزامي</span>
                  </div>
                </b-form-group>
                <b-form-group
                  class="col-md-6 mb-3"
                  label="الى : "
                  label-for="formExport.date.to"
                >
                  <date-picker
                    id="formExport.date.to"
                    type="date"
                    lang="ar"
                    value-type="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    placeholder='ادخل الصيغة التالية   "يوم - شهر - سنة"'
                    v-model="formExport.date.to"
                    :class="{ 'is-invalid': $v.formExport.date.to.$error }"
                  ></date-picker>
                  <div v-if="$v.formExport.date.to.$error" class="invalid-feedback">
                    <span v-if="!$v.formExport.date.to.required">هذا الحقل الزامي</span>
                  </div>
                </b-form-group>
              </div>
              <div>
                <hr />
                <b-button
                  class="btn-block"
                  type="button"
                  @click="download('uri_excel')"
                  variant="primary"
                  :disabled="
                    this.loadingButtonExportExcel ||
                    loadingButtonExportZip ||
                    downloadProgress
                  "
                >
                  <b-spinner v-if="this.loadingButtonExportExcel" small></b-spinner>
                  <span v-else>
                    <i class="bx bx-check font-size-16 align-middle me-2"></i>تحميل
                    البيانات</span
                  >
                </b-button>
                <b-button
                  class="btn-block"
                  style="margin-right: 10px"
                  type="button"
                  v-if="formExport.formName.value != 'booths'"
                  @click="download('uri_zip')"
                  variant="primary"
                  :disabled="
                    this.loadingButtonExportZip ||
                    loadingButtonExportExcel ||
                    downloadProgress
                  "
                >
                  <b-spinner v-if="this.loadingButtonExportZip" small></b-spinner>
                  <span v-else>
                    <i class="bx bx-check font-size-16 align-middle me-2"></i>تحميل
                    المرفقات</span
                  >
                </b-button>
              </div>
            </b-form>
            <!-- loading content -->
            <div v-else>
              <vue-content-loading :rtl="true" :width="400" :height="56">
                <rect x="0" y="4" rx="0" ry="0" width="2" height="7" />
                <rect x="4" y="6" rx="1" ry="1" width="30" height="3" />
                <rect x="35" y="7" rx="1" ry="1" width="364" height="1" />

                <rect x="0" y="17" rx="1" ry="1" width="50" height="2" />
                <rect x="0" y="21" rx="1" ry="1" width="400" height="10" />

                <rect x="0" y="39" rx="1" ry="1" width="400" height="1" />
                <rect x="0" y="43" rx="1" ry="1" width="20" height="10" />
              </vue-content-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
